/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Entry } from './Entry';
import {
    EntryFromJSON,
    EntryFromJSONTyped,
    EntryToJSON,
    EntryToJSONTyped,
} from './Entry';
import type { ConclusionGroup } from './ConclusionGroup';
import {
    ConclusionGroupFromJSON,
    ConclusionGroupFromJSONTyped,
    ConclusionGroupToJSON,
    ConclusionGroupToJSONTyped,
} from './ConclusionGroup';
import type { ResultDocumentFile } from './ResultDocumentFile';
import {
    ResultDocumentFileFromJSON,
    ResultDocumentFileFromJSONTyped,
    ResultDocumentFileToJSON,
    ResultDocumentFileToJSONTyped,
} from './ResultDocumentFile';
import type { ExpressionCCL } from './ExpressionCCL';
import {
    ExpressionCCLFromJSON,
    ExpressionCCLFromJSONTyped,
    ExpressionCCLToJSON,
    ExpressionCCLToJSONTyped,
} from './ExpressionCCL';
import type { UiIdentifier } from './UiIdentifier';
import {
    UiIdentifierFromJSON,
    UiIdentifierFromJSONTyped,
    UiIdentifierToJSON,
    UiIdentifierToJSONTyped,
} from './UiIdentifier';

/**
 * 
 * @export
 * @interface PatientCommonExpression
 */
export interface PatientCommonExpression {
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    expressionId?: number;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    conceptGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    metaDataText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isCorrected?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isInterpretable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    languageIso?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    originalText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    multiDosageText?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isMatched?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    matchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    unMatchedText?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    expressionType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    siteRoot?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    siteRootIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    siteRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    siteRootGroup?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    siteRootGroupIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    aggressorRoot?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    aggressorRootIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    aggressorRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    aggressorRootGroup?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    aggressorRootGroupIndex?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    timelineStart?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    timelineEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    durationType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    healthProType?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    findingProcedureRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAdministrationRoute?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAdministrationRouteTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctProxyKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSite?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressorTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressorProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressorProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctNestingAggressor?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctNestingAggressorTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressorContentProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctAggressorContentProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    aggressorContentRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    aggressorContentRootTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance1?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance1Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance2?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance2Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily2?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance3?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance3Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily3?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance4?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance4Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily4?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance5?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance5Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily5?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance6?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstance6Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily6?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily1?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily1Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily1Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily2Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily2Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily3Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily3Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily4Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily4Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily5Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily5Term?: string;
    /**
     * 
     * @type {number}
     * @memberof PatientCommonExpression
     */
    sctContentFamily6Index?: number;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctContentFamily6Term?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstanceKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctLabKey?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctFindingProcedure?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctFindingProcedureTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctFindingProcedureProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctFindingProcedureProxyTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isSpecialtyOverImaging?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    laterality?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    lateralityTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctBodyQualifier?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctBodyQualifierTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstanceReaction?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSubstanceReactionTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctLabCollection?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctLabCollectionTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteFinding?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteFindingTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteFindingProxy?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctSiteFindingProxyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    siteFindingRoot?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctMorphology?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctMorphologyTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctNormalityContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    numericalValue?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctUnit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    ucumUnit?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isNumerical?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    normalityType?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isNormal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isOngoing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    standardizedNumerical?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    standardizedUpperLimit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    standardizedLowerLimit?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    standardizedUnitTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isNegated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctCertaintyContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctCertaintyContextTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctProcedureContext?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctProcedureContextTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isFact?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctPersonInformer?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctPersonInformerTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctPersonSubject?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctPersonSubjectTerm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatientCommonExpression
     */
    isFamilyHistory?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    sctUnitTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    galenic?: string;
    /**
     * 
     * @type {ExpressionCCL}
     * @memberof PatientCommonExpression
     */
    expressionCcl?: ExpressionCCL;
    /**
     * 
     * @type {Entry}
     * @memberof PatientCommonExpression
     */
    entry?: Entry;
    /**
     * 
     * @type {ConclusionGroup}
     * @memberof PatientCommonExpression
     */
    conclusionGroup?: ConclusionGroup;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    text?: string;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    posoText?: string;
    /**
     * 
     * @type {UiIdentifier}
     * @memberof PatientCommonExpression
     */
    id?: UiIdentifier;
    /**
     * 
     * @type {string}
     * @memberof PatientCommonExpression
     */
    dbText?: string;
    /**
     * 
     * @type {ResultDocumentFile}
     * @memberof PatientCommonExpression
     */
    resultDocumentFile?: ResultDocumentFile;
}

/**
 * Check if a given object implements the PatientCommonExpression interface.
 */
export function instanceOfPatientCommonExpression(value: object): value is PatientCommonExpression {
    return true;
}

export function PatientCommonExpressionFromJSON(json: any): PatientCommonExpression {
    return PatientCommonExpressionFromJSONTyped(json, false);
}

export function PatientCommonExpressionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientCommonExpression {
    if (json == null) {
        return json;
    }
    return {
        
        'expressionId': json['expressionId'] == null ? undefined : json['expressionId'],
        'conceptGroupId': json['conceptGroupId'] == null ? undefined : json['conceptGroupId'],
        'metaDataText': json['metaDataText'] == null ? undefined : json['metaDataText'],
        'isCorrected': json['isCorrected'] == null ? undefined : json['isCorrected'],
        'isInterpretable': json['isInterpretable'] == null ? undefined : json['isInterpretable'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'languageIso': json['languageIso'] == null ? undefined : json['languageIso'],
        'originalText': json['originalText'] == null ? undefined : json['originalText'],
        'multiDosageText': json['multiDosageText'] == null ? undefined : json['multiDosageText'],
        'isMatched': json['isMatched'] == null ? undefined : json['isMatched'],
        'matchedText': json['matchedText'] == null ? undefined : json['matchedText'],
        'unMatchedText': json['unMatchedText'] == null ? undefined : json['unMatchedText'],
        'expressionType': json['expressionType'] == null ? undefined : json['expressionType'],
        'siteRoot': json['siteRoot'] == null ? undefined : json['siteRoot'],
        'siteRootIndex': json['siteRootIndex'] == null ? undefined : json['siteRootIndex'],
        'siteRootTerm': json['siteRootTerm'] == null ? undefined : json['siteRootTerm'],
        'siteRootGroup': json['siteRootGroup'] == null ? undefined : json['siteRootGroup'],
        'siteRootGroupIndex': json['siteRootGroupIndex'] == null ? undefined : json['siteRootGroupIndex'],
        'aggressorRoot': json['aggressorRoot'] == null ? undefined : json['aggressorRoot'],
        'aggressorRootIndex': json['aggressorRootIndex'] == null ? undefined : json['aggressorRootIndex'],
        'aggressorRootTerm': json['aggressorRootTerm'] == null ? undefined : json['aggressorRootTerm'],
        'aggressorRootGroup': json['aggressorRootGroup'] == null ? undefined : json['aggressorRootGroup'],
        'aggressorRootGroupIndex': json['aggressorRootGroupIndex'] == null ? undefined : json['aggressorRootGroupIndex'],
        'timelineStart': json['timelineStart'] == null ? undefined : json['timelineStart'],
        'timelineEnd': json['timelineEnd'] == null ? undefined : json['timelineEnd'],
        'durationType': json['durationType'] == null ? undefined : json['durationType'],
        'healthProType': json['healthProType'] == null ? undefined : json['healthProType'],
        'findingProcedureRoot': json['findingProcedureRoot'] == null ? undefined : json['findingProcedureRoot'],
        'sctAdministrationRoute': json['sctAdministrationRoute'] == null ? undefined : json['sctAdministrationRoute'],
        'sctAdministrationRouteTerm': json['sctAdministrationRouteTerm'] == null ? undefined : json['sctAdministrationRouteTerm'],
        'sctProxyKey': json['sctProxyKey'] == null ? undefined : json['sctProxyKey'],
        'sctSite': json['sctSite'] == null ? undefined : json['sctSite'],
        'sctSiteTerm': json['sctSiteTerm'] == null ? undefined : json['sctSiteTerm'],
        'sctSiteProxy': json['sctSiteProxy'] == null ? undefined : json['sctSiteProxy'],
        'sctSiteProxyTerm': json['sctSiteProxyTerm'] == null ? undefined : json['sctSiteProxyTerm'],
        'sctAggressor': json['sctAggressor'] == null ? undefined : json['sctAggressor'],
        'sctAggressorTerm': json['sctAggressorTerm'] == null ? undefined : json['sctAggressorTerm'],
        'sctAggressorProxy': json['sctAggressorProxy'] == null ? undefined : json['sctAggressorProxy'],
        'sctAggressorProxyTerm': json['sctAggressorProxyTerm'] == null ? undefined : json['sctAggressorProxyTerm'],
        'sctNestingAggressor': json['sctNestingAggressor'] == null ? undefined : json['sctNestingAggressor'],
        'sctNestingAggressorTerm': json['sctNestingAggressorTerm'] == null ? undefined : json['sctNestingAggressorTerm'],
        'sctAggressorContentProxy': json['sctAggressorContentProxy'] == null ? undefined : json['sctAggressorContentProxy'],
        'sctAggressorContentProxyTerm': json['sctAggressorContentProxyTerm'] == null ? undefined : json['sctAggressorContentProxyTerm'],
        'aggressorContentRoot': json['aggressorContentRoot'] == null ? undefined : json['aggressorContentRoot'],
        'aggressorContentRootTerm': json['aggressorContentRootTerm'] == null ? undefined : json['aggressorContentRootTerm'],
        'sctSubstance1': json['sctSubstance1'] == null ? undefined : json['sctSubstance1'],
        'sctSubstance1Term': json['sctSubstance1Term'] == null ? undefined : json['sctSubstance1Term'],
        'sctSubstance2': json['sctSubstance2'] == null ? undefined : json['sctSubstance2'],
        'sctSubstance2Term': json['sctSubstance2Term'] == null ? undefined : json['sctSubstance2Term'],
        'sctContentFamily2': json['sctContentFamily2'] == null ? undefined : json['sctContentFamily2'],
        'sctSubstance3': json['sctSubstance3'] == null ? undefined : json['sctSubstance3'],
        'sctSubstance3Term': json['sctSubstance3Term'] == null ? undefined : json['sctSubstance3Term'],
        'sctContentFamily3': json['sctContentFamily3'] == null ? undefined : json['sctContentFamily3'],
        'sctSubstance4': json['sctSubstance4'] == null ? undefined : json['sctSubstance4'],
        'sctSubstance4Term': json['sctSubstance4Term'] == null ? undefined : json['sctSubstance4Term'],
        'sctContentFamily4': json['sctContentFamily4'] == null ? undefined : json['sctContentFamily4'],
        'sctSubstance5': json['sctSubstance5'] == null ? undefined : json['sctSubstance5'],
        'sctSubstance5Term': json['sctSubstance5Term'] == null ? undefined : json['sctSubstance5Term'],
        'sctContentFamily5': json['sctContentFamily5'] == null ? undefined : json['sctContentFamily5'],
        'sctSubstance6': json['sctSubstance6'] == null ? undefined : json['sctSubstance6'],
        'sctSubstance6Term': json['sctSubstance6Term'] == null ? undefined : json['sctSubstance6Term'],
        'sctContentFamily6': json['sctContentFamily6'] == null ? undefined : json['sctContentFamily6'],
        'sctContentFamily1': json['sctContentFamily1'] == null ? undefined : json['sctContentFamily1'],
        'sctContentFamily1Index': json['sctContentFamily1Index'] == null ? undefined : json['sctContentFamily1Index'],
        'sctContentFamily1Term': json['sctContentFamily1Term'] == null ? undefined : json['sctContentFamily1Term'],
        'sctContentFamily2Index': json['sctContentFamily2Index'] == null ? undefined : json['sctContentFamily2Index'],
        'sctContentFamily2Term': json['sctContentFamily2Term'] == null ? undefined : json['sctContentFamily2Term'],
        'sctContentFamily3Index': json['sctContentFamily3Index'] == null ? undefined : json['sctContentFamily3Index'],
        'sctContentFamily3Term': json['sctContentFamily3Term'] == null ? undefined : json['sctContentFamily3Term'],
        'sctContentFamily4Index': json['sctContentFamily4Index'] == null ? undefined : json['sctContentFamily4Index'],
        'sctContentFamily4Term': json['sctContentFamily4Term'] == null ? undefined : json['sctContentFamily4Term'],
        'sctContentFamily5Index': json['sctContentFamily5Index'] == null ? undefined : json['sctContentFamily5Index'],
        'sctContentFamily5Term': json['sctContentFamily5Term'] == null ? undefined : json['sctContentFamily5Term'],
        'sctContentFamily6Index': json['sctContentFamily6Index'] == null ? undefined : json['sctContentFamily6Index'],
        'sctContentFamily6Term': json['sctContentFamily6Term'] == null ? undefined : json['sctContentFamily6Term'],
        'sctSubstanceKey': json['sctSubstanceKey'] == null ? undefined : json['sctSubstanceKey'],
        'sctLabKey': json['sctLabKey'] == null ? undefined : json['sctLabKey'],
        'sctFindingProcedure': json['sctFindingProcedure'] == null ? undefined : json['sctFindingProcedure'],
        'sctFindingProcedureTerm': json['sctFindingProcedureTerm'] == null ? undefined : json['sctFindingProcedureTerm'],
        'sctFindingProcedureProxy': json['sctFindingProcedureProxy'] == null ? undefined : json['sctFindingProcedureProxy'],
        'sctFindingProcedureProxyTerm': json['sctFindingProcedureProxyTerm'] == null ? undefined : json['sctFindingProcedureProxyTerm'],
        'isSpecialtyOverImaging': json['isSpecialtyOverImaging'] == null ? undefined : json['isSpecialtyOverImaging'],
        'laterality': json['laterality'] == null ? undefined : json['laterality'],
        'lateralityTerm': json['lateralityTerm'] == null ? undefined : json['lateralityTerm'],
        'sctBodyQualifier': json['sctBodyQualifier'] == null ? undefined : json['sctBodyQualifier'],
        'sctBodyQualifierTerm': json['sctBodyQualifierTerm'] == null ? undefined : json['sctBodyQualifierTerm'],
        'sctSubstanceReaction': json['sctSubstanceReaction'] == null ? undefined : json['sctSubstanceReaction'],
        'sctSubstanceReactionTerm': json['sctSubstanceReactionTerm'] == null ? undefined : json['sctSubstanceReactionTerm'],
        'sctLabCollection': json['sctLabCollection'] == null ? undefined : json['sctLabCollection'],
        'sctLabCollectionTerm': json['sctLabCollectionTerm'] == null ? undefined : json['sctLabCollectionTerm'],
        'sctSiteFinding': json['sctSiteFinding'] == null ? undefined : json['sctSiteFinding'],
        'sctSiteFindingTerm': json['sctSiteFindingTerm'] == null ? undefined : json['sctSiteFindingTerm'],
        'sctSiteFindingProxy': json['sctSiteFindingProxy'] == null ? undefined : json['sctSiteFindingProxy'],
        'sctSiteFindingProxyTerm': json['sctSiteFindingProxyTerm'] == null ? undefined : json['sctSiteFindingProxyTerm'],
        'siteFindingRoot': json['siteFindingRoot'] == null ? undefined : json['siteFindingRoot'],
        'sctMorphology': json['sctMorphology'] == null ? undefined : json['sctMorphology'],
        'sctMorphologyTerm': json['sctMorphologyTerm'] == null ? undefined : json['sctMorphologyTerm'],
        'sctNormalityContext': json['sctNormalityContext'] == null ? undefined : json['sctNormalityContext'],
        'numericalValue': json['numericalValue'] == null ? undefined : json['numericalValue'],
        'sctUnit': json['sctUnit'] == null ? undefined : json['sctUnit'],
        'ucumUnit': json['ucumUnit'] == null ? undefined : json['ucumUnit'],
        'isNumerical': json['isNumerical'] == null ? undefined : json['isNumerical'],
        'normalityType': json['normalityType'] == null ? undefined : json['normalityType'],
        'isNormal': json['isNormal'] == null ? undefined : json['isNormal'],
        'isOngoing': json['isOngoing'] == null ? undefined : json['isOngoing'],
        'standardizedNumerical': json['standardizedNumerical'] == null ? undefined : json['standardizedNumerical'],
        'standardizedUpperLimit': json['standardizedUpperLimit'] == null ? undefined : json['standardizedUpperLimit'],
        'standardizedLowerLimit': json['standardizedLowerLimit'] == null ? undefined : json['standardizedLowerLimit'],
        'standardizedUnitTerm': json['standardizedUnitTerm'] == null ? undefined : json['standardizedUnitTerm'],
        'isNegated': json['isNegated'] == null ? undefined : json['isNegated'],
        'sctCertaintyContext': json['sctCertaintyContext'] == null ? undefined : json['sctCertaintyContext'],
        'sctCertaintyContextTerm': json['sctCertaintyContextTerm'] == null ? undefined : json['sctCertaintyContextTerm'],
        'sctProcedureContext': json['sctProcedureContext'] == null ? undefined : json['sctProcedureContext'],
        'sctProcedureContextTerm': json['sctProcedureContextTerm'] == null ? undefined : json['sctProcedureContextTerm'],
        'isFact': json['isFact'] == null ? undefined : json['isFact'],
        'sctPersonInformer': json['sctPersonInformer'] == null ? undefined : json['sctPersonInformer'],
        'sctPersonInformerTerm': json['sctPersonInformerTerm'] == null ? undefined : json['sctPersonInformerTerm'],
        'sctPersonSubject': json['sctPersonSubject'] == null ? undefined : json['sctPersonSubject'],
        'sctPersonSubjectTerm': json['sctPersonSubjectTerm'] == null ? undefined : json['sctPersonSubjectTerm'],
        'isFamilyHistory': json['isFamilyHistory'] == null ? undefined : json['isFamilyHistory'],
        'sctUnitTerm': json['sctUnitTerm'] == null ? undefined : json['sctUnitTerm'],
        'galenic': json['galenic'] == null ? undefined : json['galenic'],
        'expressionCcl': json['expressionCcl'] == null ? undefined : ExpressionCCLFromJSON(json['expressionCcl']),
        'entry': json['entry'] == null ? undefined : EntryFromJSON(json['entry']),
        'conclusionGroup': json['conclusionGroup'] == null ? undefined : ConclusionGroupFromJSON(json['conclusionGroup']),
        'text': json['text'] == null ? undefined : json['text'],
        'posoText': json['posoText'] == null ? undefined : json['posoText'],
        'id': json['id'] == null ? undefined : UiIdentifierFromJSON(json['id']),
        'dbText': json['dbText'] == null ? undefined : json['dbText'],
        'resultDocumentFile': json['resultDocumentFile'] == null ? undefined : ResultDocumentFileFromJSON(json['resultDocumentFile']),
    };
}

export function PatientCommonExpressionToJSON(json: any): PatientCommonExpression {
    return PatientCommonExpressionToJSONTyped(json, false);
}

export function PatientCommonExpressionToJSONTyped(value?: PatientCommonExpression | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expressionId': value['expressionId'],
        'conceptGroupId': value['conceptGroupId'],
        'metaDataText': value['metaDataText'],
        'isCorrected': value['isCorrected'],
        'isInterpretable': value['isInterpretable'],
        'created': value['created'],
        'updated': value['updated'],
        'languageIso': value['languageIso'],
        'originalText': value['originalText'],
        'multiDosageText': value['multiDosageText'],
        'isMatched': value['isMatched'],
        'matchedText': value['matchedText'],
        'unMatchedText': value['unMatchedText'],
        'expressionType': value['expressionType'],
        'siteRoot': value['siteRoot'],
        'siteRootIndex': value['siteRootIndex'],
        'siteRootTerm': value['siteRootTerm'],
        'siteRootGroup': value['siteRootGroup'],
        'siteRootGroupIndex': value['siteRootGroupIndex'],
        'aggressorRoot': value['aggressorRoot'],
        'aggressorRootIndex': value['aggressorRootIndex'],
        'aggressorRootTerm': value['aggressorRootTerm'],
        'aggressorRootGroup': value['aggressorRootGroup'],
        'aggressorRootGroupIndex': value['aggressorRootGroupIndex'],
        'timelineStart': value['timelineStart'],
        'timelineEnd': value['timelineEnd'],
        'durationType': value['durationType'],
        'healthProType': value['healthProType'],
        'findingProcedureRoot': value['findingProcedureRoot'],
        'sctAdministrationRoute': value['sctAdministrationRoute'],
        'sctAdministrationRouteTerm': value['sctAdministrationRouteTerm'],
        'sctProxyKey': value['sctProxyKey'],
        'sctSite': value['sctSite'],
        'sctSiteTerm': value['sctSiteTerm'],
        'sctSiteProxy': value['sctSiteProxy'],
        'sctSiteProxyTerm': value['sctSiteProxyTerm'],
        'sctAggressor': value['sctAggressor'],
        'sctAggressorTerm': value['sctAggressorTerm'],
        'sctAggressorProxy': value['sctAggressorProxy'],
        'sctAggressorProxyTerm': value['sctAggressorProxyTerm'],
        'sctNestingAggressor': value['sctNestingAggressor'],
        'sctNestingAggressorTerm': value['sctNestingAggressorTerm'],
        'sctAggressorContentProxy': value['sctAggressorContentProxy'],
        'sctAggressorContentProxyTerm': value['sctAggressorContentProxyTerm'],
        'aggressorContentRoot': value['aggressorContentRoot'],
        'aggressorContentRootTerm': value['aggressorContentRootTerm'],
        'sctSubstance1': value['sctSubstance1'],
        'sctSubstance1Term': value['sctSubstance1Term'],
        'sctSubstance2': value['sctSubstance2'],
        'sctSubstance2Term': value['sctSubstance2Term'],
        'sctContentFamily2': value['sctContentFamily2'],
        'sctSubstance3': value['sctSubstance3'],
        'sctSubstance3Term': value['sctSubstance3Term'],
        'sctContentFamily3': value['sctContentFamily3'],
        'sctSubstance4': value['sctSubstance4'],
        'sctSubstance4Term': value['sctSubstance4Term'],
        'sctContentFamily4': value['sctContentFamily4'],
        'sctSubstance5': value['sctSubstance5'],
        'sctSubstance5Term': value['sctSubstance5Term'],
        'sctContentFamily5': value['sctContentFamily5'],
        'sctSubstance6': value['sctSubstance6'],
        'sctSubstance6Term': value['sctSubstance6Term'],
        'sctContentFamily6': value['sctContentFamily6'],
        'sctContentFamily1': value['sctContentFamily1'],
        'sctContentFamily1Index': value['sctContentFamily1Index'],
        'sctContentFamily1Term': value['sctContentFamily1Term'],
        'sctContentFamily2Index': value['sctContentFamily2Index'],
        'sctContentFamily2Term': value['sctContentFamily2Term'],
        'sctContentFamily3Index': value['sctContentFamily3Index'],
        'sctContentFamily3Term': value['sctContentFamily3Term'],
        'sctContentFamily4Index': value['sctContentFamily4Index'],
        'sctContentFamily4Term': value['sctContentFamily4Term'],
        'sctContentFamily5Index': value['sctContentFamily5Index'],
        'sctContentFamily5Term': value['sctContentFamily5Term'],
        'sctContentFamily6Index': value['sctContentFamily6Index'],
        'sctContentFamily6Term': value['sctContentFamily6Term'],
        'sctSubstanceKey': value['sctSubstanceKey'],
        'sctLabKey': value['sctLabKey'],
        'sctFindingProcedure': value['sctFindingProcedure'],
        'sctFindingProcedureTerm': value['sctFindingProcedureTerm'],
        'sctFindingProcedureProxy': value['sctFindingProcedureProxy'],
        'sctFindingProcedureProxyTerm': value['sctFindingProcedureProxyTerm'],
        'isSpecialtyOverImaging': value['isSpecialtyOverImaging'],
        'laterality': value['laterality'],
        'lateralityTerm': value['lateralityTerm'],
        'sctBodyQualifier': value['sctBodyQualifier'],
        'sctBodyQualifierTerm': value['sctBodyQualifierTerm'],
        'sctSubstanceReaction': value['sctSubstanceReaction'],
        'sctSubstanceReactionTerm': value['sctSubstanceReactionTerm'],
        'sctLabCollection': value['sctLabCollection'],
        'sctLabCollectionTerm': value['sctLabCollectionTerm'],
        'sctSiteFinding': value['sctSiteFinding'],
        'sctSiteFindingTerm': value['sctSiteFindingTerm'],
        'sctSiteFindingProxy': value['sctSiteFindingProxy'],
        'sctSiteFindingProxyTerm': value['sctSiteFindingProxyTerm'],
        'siteFindingRoot': value['siteFindingRoot'],
        'sctMorphology': value['sctMorphology'],
        'sctMorphologyTerm': value['sctMorphologyTerm'],
        'sctNormalityContext': value['sctNormalityContext'],
        'numericalValue': value['numericalValue'],
        'sctUnit': value['sctUnit'],
        'ucumUnit': value['ucumUnit'],
        'isNumerical': value['isNumerical'],
        'normalityType': value['normalityType'],
        'isNormal': value['isNormal'],
        'isOngoing': value['isOngoing'],
        'standardizedNumerical': value['standardizedNumerical'],
        'standardizedUpperLimit': value['standardizedUpperLimit'],
        'standardizedLowerLimit': value['standardizedLowerLimit'],
        'standardizedUnitTerm': value['standardizedUnitTerm'],
        'isNegated': value['isNegated'],
        'sctCertaintyContext': value['sctCertaintyContext'],
        'sctCertaintyContextTerm': value['sctCertaintyContextTerm'],
        'sctProcedureContext': value['sctProcedureContext'],
        'sctProcedureContextTerm': value['sctProcedureContextTerm'],
        'isFact': value['isFact'],
        'sctPersonInformer': value['sctPersonInformer'],
        'sctPersonInformerTerm': value['sctPersonInformerTerm'],
        'sctPersonSubject': value['sctPersonSubject'],
        'sctPersonSubjectTerm': value['sctPersonSubjectTerm'],
        'isFamilyHistory': value['isFamilyHistory'],
        'sctUnitTerm': value['sctUnitTerm'],
        'galenic': value['galenic'],
        'expressionCcl': ExpressionCCLToJSON(value['expressionCcl']),
        'entry': EntryToJSON(value['entry']),
        'conclusionGroup': ConclusionGroupToJSON(value['conclusionGroup']),
        'text': value['text'],
        'posoText': value['posoText'],
        'id': UiIdentifierToJSON(value['id']),
        'dbText': value['dbText'],
        'resultDocumentFile': ResultDocumentFileToJSON(value['resultDocumentFile']),
    };
}

